import { Tooltip } from 'bootstrap';

const tooltipDirective = {
  mounted(el: HTMLElement) {
    new Tooltip(el);
  },
  unmounted(el: HTMLElement) {
    const tooltip = Tooltip.getInstance(el);
    if (tooltip) {
      tooltip.dispose();
    }
  },
  updated(el: HTMLElement) {
    const tooltip = Tooltip.getInstance(el);
    if (tooltip) {
      (tooltip as any)._config.title = el.getAttribute('title') || el.getAttribute('data-bs-title') || '';
    }
  }
};

export default {
  install(app: any) {
    app.directive('tooltip', tooltipDirective);
  }
};
